import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

interface StatusProps {
	value: string;
	color: 'red' | 'yellow' | 'green' | 'grey';
}

export const Status = ({ value, color }: StatusProps) => {
	const { t } = useTranslation();
	return (
		<div
			className={cn(
				'flex items-center justify-center rounded border-2 w-[80px] h-[23px]',
				{
					'bg-green-light border-green text-green': color === 'green',
					'bg-red-light border-red text-red': color === 'red',
					'bg-yellow-100 border-yellow-600 text-yellow-600': color === 'yellow',
					'bg-gray-100 border-gray-400 text-gray-400': color === 'grey',
				}
			)}
		>
			<span className='font-normal text-xs'>{value}</span>
		</div>
	);
};
